export type ConciergeTokenPair = { canvas: string; accent: string };

// The host declares neither name anywhere, so a non-empty computed value is itself
// proof the partner's stylesheet set it — deliberately no comparison against a host
// default. The browser resolves var() before returning a computed custom property,
// but does not normalize notation, so values can still arrive as rgb().
const CANVAS_TOKEN = '--dcm-concierge-theme-canvas';
const ACCENT_TOKEN = '--dcm-concierge-theme-accent';

export function readConciergeThemeTokens(element?: HTMLElement): ConciergeTokenPair | null {
  // getComputedStyle is client-only; SSR and the first client render see nothing.
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return null;
  }

  const root = element ?? document.documentElement;
  if (!root) {
    return null;
  }

  const styles = window.getComputedStyle(root);
  const canvas = styles.getPropertyValue(CANVAS_TOKEN).trim();
  const accent = styles.getPropertyValue(ACCENT_TOKEN).trim();

  // Atomic: a lone token is ignored rather than paired with a host value.
  if (!canvas || !accent) {
    return null;
  }

  return { canvas, accent };
}
